"use strict";

(function () {
  'use strict';

  angular.module('vendor.constants', []).constant('Moment', moment).constant('JsSHA', jsSHA);
})();